//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CashCategorySearchType } from './Enums';

export class CashCategorySearchOptions extends ItemBase {
    IDs: string[] = [];
    CategoryTypes: CashCategorySearchType[] = [];
    Active: boolean | null = null;
    SearchText: string | null = null;

    constructor(initializer?: Partial<CashCategorySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashCategorySearchOptions";
}
